import { render, staticRenderFns } from "./FlightSegment.vue?vue&type=template&id=6b8b3fbd&"
import script from "./FlightSegment.vue?vue&type=script&lang=js&"
export * from "./FlightSegment.vue?vue&type=script&lang=js&"
import style0 from "./FlightSegment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports